/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { createContextRoute, NavTabBarComponent } from '@gh/common-internal-shared';
import { getRouteInitData } from '@gh/common-shared';
import { JobDetailsBillingTabComponent } from './job-details-billing-tab/job-details-billing-tab.component';
import { JobBilling } from '../../resources/cm.model';

const CURRENT_TAB = 'common';

@Component({
  selector:    'gh-cm-job-details-tab-container',
  template: require('./cm-job-details-tab-container.component.html'),
})
export class CmJobDetailsTabContainerComponent implements OnInit {
  billing: JobBilling;
  @ViewChild(NavTabBarComponent, { static: true }) navigation: NavTabBarComponent;
  routes = [
    createContextRoute({
      component: JobDetailsBillingTabComponent,
      path:      'common',
    }),
  ];

  constructor(
    private route: ActivatedRoute,
  ) {

  }

  get currentTab(): string {
    return CURRENT_TAB;
  }

  ngOnInit(): void {
    const { billing } = getRouteInitData(this.route);
    this.billing = billing;
  }
}
